class TokenService {
    getLocalRefreshToken() {
      const token = localStorage.getItem("access_token");
      return token;
    }
  
    getLocalAccessToken() {
      const token = localStorage.getItem("access_token");
      return token;
    }
  
    updateLocalAccessToken(token) {
      localStorage.setItem("access_token", token);
    }
  
    getUser() {
      return JSON.parse(localStorage.getItem("user"));
    }
  
    setUser(user) {
      console.log(JSON.stringify(user));
      localStorage.setItem("user", JSON.stringify(user));
    }
  
    removeUser() {
      localStorage.removeItem('user');
      localStorage.removeItem('rol');
      localStorage.removeItem('access_token');
    }
  }
  
  export default new TokenService();